<template>
    <div class="course-visual">
        <img class="course-visual__image img-fluid" :class="imageClass" :src="course.visual.thumbnail" :alt="alt">
        <template v-if="course.marketing_message">
            <div class="course-visual__marketing-message">
                {{ course.marketing_message }}
            </div>
        </template>
    </div>
</template>

<script>
    import { stripTags } from "../util";

    export default  {
        props: {
            course: Object,
            imageClass: String,
        },
        computed: {
            alt() {
                return this.course.thumbnail?.legend ?? stripTags(this.course.title);
            },
        }
    }
</script>
